import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Calendar, MapPin } from "lucide-react";

export default function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/events").then((r) => {
      // Sort events by date DESC so latest dates appear first
      const sorted = [...r.data].sort((a, b) => (b.date || "").localeCompare(a.date || ""));
      setEvents(sorted);
    }).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="events-page">
      <section className="bg-bone border-b border-border">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
          <p className="overline text-terracotta mb-4">Gather</p>
          <h1 className="font-heading font-black text-5xl sm:text-6xl tracking-tighter text-olive leading-[0.95] max-w-3xl">
            Upcoming <em className="italic font-light text-terracotta">Events</em>
          </h1>
          <p className="mt-6 text-ink/70 text-lg max-w-2xl">
            Come encounter God with us. Services, conferences, and gatherings throughout the year.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        {loading ? (
          <p className="text-muted_ink">Loading events…</p>
        ) : events.length === 0 ? (
          <p className="text-muted_ink">No events scheduled yet.</p>
        ) : (
          <div className="space-y-16">
            {events.map((e, i) => (
              <article key={e.id} className={`grid md:grid-cols-12 gap-8 items-center ${i % 2 === 1 ? "md:[&>div:first-child]:order-2" : ""}`} data-testid={`event-${e.id}`}>
                <div className="md:col-span-7">
                  {e.image_url ? (
                    <img src={e.image_url} alt={e.title} className="w-full h-auto block" />
                  ) : (
                    <div className="w-full aspect-[16/10] bg-cream border border-border" />
                  )}
                </div>
                <div className="md:col-span-5">
                  <p className="overline text-terracotta mb-3">
                    {new Date(e.date).toLocaleDateString("en-ZA", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}
                  </p>
                  <h2 className="font-heading font-black text-3xl sm:text-4xl tracking-tight text-olive">{e.title}</h2>
                  <p className="mt-4 text-ink/75 leading-relaxed whitespace-pre-line">{e.description}</p>
                  <div className="mt-6 flex items-start gap-2 text-sm text-muted_ink">
                    <MapPin size={16} className="mt-0.5 text-terracotta" /> {e.location}
                  </div>
                  <div className="mt-2 flex items-start gap-2 text-sm text-muted_ink">
                    <Calendar size={16} className="mt-0.5 text-terracotta" />
                    {new Date(e.date).toLocaleDateString("en-ZA", { dateStyle: "full" })}
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
